import React, { useEffect, useState } from "react";
import "./style.scss";
import { connect } from "react-redux";
import moment from "moment";
// import CertificateIcon from "images/certificatesIcon.js";
import { actions as courseActions } from "redux/actions/course-actions";
import { courseSelector } from "redux/selectors/courseSelector";
import CardCertificate from "components/CardCertificateProgram";
import { homeSelector } from "redux/selectors/homeSelector";
import { Space } from "antd";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";
import { CERTIFICATES } from "enum/QueryKeys";
import { useCertificateStore } from "store/certificate";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";

const Certificates = ({ userProfile }) => {
  const certificateStore = useCertificateStore();
  const location = useLocation();
  const { tab: defaultTab } = queryString.parse(location.search);
  const [page, setPage] = useState(1);
  const [tab, setTab] = useState(+defaultTab || 1);
  const history = useHistory();

  const { data: allNewCourses } = useQuery({
    queryKey: [CERTIFICATES],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificates`);

      return data?.courses || [];
    },
  });

  const orderCertificates = (data, isMyPrograms = false) => {
    // let addStartTime = [];
    let arrayOrderTime = [];

    arrayOrderTime = data?.sort(function (a, b) {
      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return 1;
      }
      if (a.title.toLowerCase() < b.title.toLowerCase()) {
        return -1;
      }
      return 0;
    });

    // arrayOrderTime?.forEach((e) => {
    //   let arrayActu = sortDates(e?.classes)
    //   addStartTime = [...addStartTime,{
    //     ...e,
    //     startTime: arrayActu[0]?.startTime
    //   }]
    // })

    // arrayOrderTime = sortDates(addStartTime)

    arrayOrderTime = Array.isArray(arrayOrderTime)
      ? (arrayOrderTime || []).sort((a, b) => {
          let aTime = moment(a.startDate, "YYYYMMDDHHmm").format(
            "YYYYMMDDHHmm"
          );
          let bTime = moment(b.startDate, "YYYYMMDDHHmm").format(
            "YYYYMMDDHHmm"
          );

          return Number(aTime) - Number(bTime);
        })
      : [];

    let filteredCertificates = [...(arrayOrderTime || [])];

    if (!isMyPrograms) {
      const pstTimeNow = moment.tz("America/Los_Angeles");

      const timeNow = pstTimeNow.format("YYYY-MM-DDTHH:mm:ss") + "Z";
      filteredCertificates = arrayOrderTime.filter((item) =>
        moment.utc(timeNow).isBefore(moment.utc(item.startDate).add(1, "week"))
      );
    }

    return filteredCertificates;
  };

  const filterMyCertificatePrograms = (data, type = null) => {
    return data?.filter((e) => {
      const userIndex = (e?.CertificateUsers || [])?.findIndex(
        (user) => user.UserId === userProfile.id
      );

      const graduationClass = e.CourseClasses.find(
        (certClass) => certClass.classType === "graduation"
      );

      if (!graduationClass) return false

      const hasNotEnded = moment
        .utc(graduationClass?.endTime)
        .isAfter(moment());

      // const hasProgramStarted = moment
      //   .utc(graduationClass?.startTime)
      //   .isBefore(moment());

      const isEnrolled = userIndex !== -1;

      if (type === "past") {
        return isEnrolled && !hasNotEnded;
      } else if (type === "ongoing") {
        return isEnrolled && hasNotEnded;
      } else {
        return isEnrolled;
      }
    });
  };

  const hasNotification = filterMyCertificatePrograms(
    orderCertificates(allNewCourses, true)
  ).some((certificateProgram) => {
    return (certificateProgram.CertificateNotifications ?? []).some(
      (certificateNotification) => {
        return !certificateNotification.readers.includes(userProfile.id);
      }
    );
  });

  function groupByYearAndSort(items) {
    // First, create a map to hold items grouped by year
    const groupedByYear = new Map();

    items.forEach((item) => {
      // Extract the year from the startDate using moment.js
      const year = moment(item.startDate).year();

      // If this year doesn't exist in our map yet, create an array for it
      if (!groupedByYear.has(year)) {
        groupedByYear.set(year, []);
      }

      // Add the item to the appropriate year group
      groupedByYear.get(year).push(item);
    });

    // For each year group, sort the items by startDate in descending order (most recent first)
    groupedByYear.forEach((itemsInYear, year) => {
      itemsInYear.sort(
        (a, b) => moment(b.startDate).valueOf() - moment(a.startDate).valueOf()
      );
    });

    // Get all years and sort them in descending order
    const sortedYears = Array.from(groupedByYear.keys()).sort((a, b) => b - a);

    // Instead of converting to an object first, directly create the array of entries
    // with years already in the correct order
    return sortedYears.map((year) => [
      year.toString(),
      groupedByYear.get(year),
    ]);
  }

  return (
    <div className="container-certificates">
      <div className="container-one">
        <div className="container-two">
          <div className="container-title-certificate"></div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <div
              className={
                tab === 1
                  ? "title-list-certificates"
                  : "title-list-certificates2"
              }
              onClick={() => {
                setTab(1);
              }}
            >
              Certificate Programs Available
            </div>
            {filterMyCertificatePrograms(
              orderCertificates(allNewCourses, true),
              "ongoing"
            ).length > 0 && (
              <div
                className={
                  tab === 2
                    ? "title-list-certificates"
                    : "title-list-certificates2"
                }
                onClick={() => setTab(2)}
              >
                My Certificate Programs Dashboards
                {hasNotification && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "2px",
                      width: "16px",
                      height: "16px",
                      backgroundColor: "red",
                      borderRadius: "50%",
                      border: "2px solid white",
                    }}
                  />
                )}
              </div>
            )}
            {filterMyCertificatePrograms(
              orderCertificates(allNewCourses, true),
              "past"
            ).length > 0 && (
              <div
                className={
                  tab === 3
                    ? "title-list-certificates"
                    : "title-list-certificates2"
                }
                onClick={() => setTab(3)}
              >
                Past Program Dashboards
                {hasNotification && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "2px",
                      width: "16px",
                      height: "16px",
                      backgroundColor: "red",
                      borderRadius: "50%",
                      border: "2px solid white",
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        {/*<div className="container-banner">*/}
        {/*  <div*/}
        {/*    className="container-banner-logo"*/}
        {/*    style={{*/}
        {/*      width: "150px",*/}
        {/*    }}*/}
        {/*  ></div>*/}
        {/*</div>*/}
      </div>
      <div className={tab !== 3 ? "container-list-certificates" : ""}>
        {tab === 1 &&
          orderCertificates(allNewCourses)?.map((e, index) => {
            const userIndex = (e?.CertificateUsers || [])?.findIndex(
              (user) =>
                user.UserId === userProfile.id && user.status === "active"
            );
            const userRegistered = userIndex !== -1 ? true : false;

            return (
              <CardCertificate
                key={index}
                certificate={e}
                onClick={() => {
                  certificateStore.setCurrentCertificate(e);
                }}
                userRegistered={userRegistered}
                userProfile={userProfile}
              />
            );
          })}
        {tab === 2 &&
          filterMyCertificatePrograms(
            orderCertificates(allNewCourses, true),
            "ongoing"
          )?.map((e, index) => {
            const hasNotification = e.CertificateNotifications.some(
              (certificateNotification) => {
                return !certificateNotification.readers.includes(
                  userProfile.id
                );
              }
            );
            return (
              <CardCertificate
                key={index}
                certificate={e}
                onClick={() => {
                  // setCourseNew(e);
                }}
                userDashBoard={true}
                userProfile={userProfile}
                isMyProgram={true}
                hasNotification={hasNotification}
              />
            );
          })}
        {tab === 3 &&
          groupByYearAndSort(
            filterMyCertificatePrograms(
              orderCertificates(allNewCourses, true),
              "past"
            )
          )?.map(([year, programs]) => {
            return (
              <div style={{ marginTop: "1rem" }}>
                <h2>{year}</h2>
                <div className="container-list-certificates">
                  {programs.map((e, index) => {
                    const hasNotification = e.CertificateNotifications.some(
                      (certificateNotification) => {
                        return !certificateNotification.readers.includes(
                          userProfile.id
                        );
                      }
                    );
                    return (
                      <CardCertificate
                        key={index}
                        certificate={e}
                        onClick={() => {
                          // setCourseNew(e);
                        }}
                        userDashBoard={true}
                        userProfile={userProfile}
                        isMyProgram={true}
                        hasNotification={hasNotification}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: homeSelector(state).userProfile,
});

export default connect(mapStateToProps)(Certificates);
